<template>
  <div id="app">
    <T1HeadScripts rodzajstrony="front" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <T1Content />
      <!-- <T1Newsletter /> -->
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1Content from "./components/T1Content";
// import T1Newsletter from "./components/T1Newsletter";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "app",
  components: {
    T1HeadScripts,
    T1Header,
    T1Content,
    // T1Newsletter,
    T1Footer
  },
  mounted() {
    console.log("ENV: " + `${process.env.VUE_APP_URI}`);
  }
};
</script>

<style lang="scss">
@import "@/scss/common-styles";
</style>
